export const Influencers = () => {
  window.location.href = "/influencers/hashtag";

  return null;
};
